import {
    CourseLocations,
    ExistingPassenger,
    Station,
    StationAddress,
} from 'src/screens/Main/components/AddLineForm/types';
import { WsCourseDataItem } from 'src/types/passengersManager/courseChoosingTypes';
import { CarType } from 'src/types/lines/api/apiProccessed.types';
import { ApiCallStatus } from '../apiCommon.types';
import { ParsedCoursePassenger, ParsedCourseStation } from './api/types';
import { IEditLine, ILine, IStation } from '../line';

export enum LoadingState {
    NotLoading = '',
    LoadingConfirm = 'LOADING_CONFIRM',
    LoadingCancel = 'LOADING_CANCEL',
}

/*
export interface Form {
    isStationValid: boolean;
    data: {
        stations: Station[];
        carId: string | null;
    };
    isOpen: boolean;
    isSubmitting: boolean;
    editedLineId?: string | null;
    passengersForm: {
        isOpen: boolean;
        newPassengerForm: {
            // if open && not adding new passenger
            // -> editing existing passenger
            isAddingNewPassenger: boolean;
            isOpen: boolean;
            oldPassengerData: ExistingPassenger | {};
        };
        lastSubmit: Date | null;
        stationId: string;
        selectedPassengersLst: ExistingPassenger[];
    };
}

export interface UiState {
    form: Form;
    common: {
        lastFormSubmit: Date | null;
        selectClientIdOnTableFilters: null | number;
        error: {
            msg: string;
            code: string | null;
        };
        lineActions: {
            isConfirmationDialogOpen: boolean;
            dataItem: ILine | unknown | null;
        };
    };
    // data: { [key: string]: any };
}

export interface NewClient {
    clientCode: string;
    clientName: string;
    firstDayOfWeek: number;
    maxMinuteToBlockNewLine: number;
}

export interface DataState {
    getPassengersShortDetails: {
        status: ApiCallStatus;
        data: ExistingPassenger[];
    };
    setPassenger: {
        status: ApiCallStatus;
        data: { passCode: string };
    };
    setLine: {
        status: ApiCallStatus;
        data: {};
    };
    getCarTypes: {
        status: null;
        data: CarType[];
    };
    delLine: {
        status: ApiCallStatus;
        data: {};
    };
    clients: NewClient[];
}

export interface LinesSliceState {
    ui: UiState;
    data: DataState;
}
*/

export interface Form {
    isStationValid: boolean;
    data: {
        stations: Station[];
        carId: string | null;
        startAddress: StationAddress | IStation | ParsedCourseStation | null;
        endAddress: StationAddress | IStation | ParsedCourseStation | null;
    };
    triggerDirections: number;
    isDirectionsTriggeredFromEdit: boolean;
    isTriggeredFromFromImport: boolean;
    isOnEdit: boolean;
    lineOnEdit: IEditLine | null;
    editedLineClientId: number | null;
    isOpen: boolean;
    isSubmitting: boolean;
    editedLineId?: string | null;
    importedCourseCode: null | string;
    addressesInputConfig: {
        autoCompleteInputIds: string[];
    };
    passengersForm: {
        isOpen: boolean;
        newPassengerForm: {
            // if open && not adding new passenger
            // -> editing existing passenger
            isAddingNewPassenger: boolean;
            isOpen: boolean;
            oldPassengerData: ExistingPassenger | {};
        };
        lastSubmit: Date | null;
        stationId: string;
        selectedPassengersLst: ExistingPassenger[];
    };
    storedCoursesImportForm: {
        isOpen: boolean;
        selectedCourseData: {
            passengers: ParsedCoursePassenger[];
            code: string;
            locations: CourseLocations | null;
        };
        importStationsModal: {
            isOpen: boolean;
            isLoading: LoadingState;
        };
    };
    isFloatMapExpanded: boolean;
    isInjectionCompleted: boolean;
}

export interface UiState {
    form: Form;
    common: {
        focusedLineId: number | null;
        lastFormSubmit: Date | null;
        selectClientIdOnTableFilters: null | number;
        linesSelectedIds: number[];
        error: {
            msg: string;
            code: string | null;
        };
        lineActions: {
            isConfirmationDialogOpen: boolean;
            dataItem: ILine | unknown | null;
            isCopyRideModalOpen: boolean;
        };
    };
}

export interface NewClient {
    clientCode: string;
    clientName: string;
    firstDayOfWeek: number;
    maxMinuteToBlockNewLine: number;
    referEmailList: string;
}

export interface DataState {
    getPassengersShortDetails: {
        status: ApiCallStatus;
        data: ExistingPassenger[];
    };
    setPassenger: {
        status: ApiCallStatus;
        data: { passCode: string };
    };
    setLine: {
        status: ApiCallStatus;
        data: {};
    };
    getCarTypes: {
        status: null;
        data: CarType[];
    };
    getAccountCourses: {
        status: ApiCallStatus;
        data: WsCourseDataItem[];
    };
    delLine: {
        status: ApiCallStatus;
        data: {};
    };
    clients: NewClient[];
    lastUsedCoursePassengers: ParsedCoursePassenger[];
}

export interface LinesSliceState {
    ui: UiState;
    data: DataState;
}
